import { render, staticRenderFns } from "./QuestionEditInputs.vue?vue&type=template&id=256c242f&"
import script from "./QuestionEditInputs.vue?vue&type=script&lang=js&"
export * from "./QuestionEditInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports